// A cover that fails to load should look like a book, not like a hole.
//
// Every cover URL we store points at someone else's server: Open Library,
// Google Books, Goodreads. Those 404, get pulled, or rate-limit us, and when
// that happens the <img> renders nothing at all — an empty box the same colour
// as the container behind it.
//
// The existing `cover_url ? <img> : <placeholder>` checks only whether we HAVE
// a URL, not whether it WORKED, so a broken link skips the placeholder
// entirely. This closes that gap.
//
// Swapping `src` rather than hiding the element and rewriting the parent: the
// parent often holds other children (remove buttons, badges, overlays) and
// clearing its contents would take those with it.

// Brand gradient (forest to rust) with a book glyph. Inline so it costs no
// request and cannot itself fail to load.
const PLACEHOLDER =
  'data:image/svg+xml;charset=utf-8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 120" preserveAspectRatio="none">
       <defs>
         <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
           <stop offset="0" stop-color="#2d4a3e"/>
           <stop offset="1" stop-color="#b85c38"/>
         </linearGradient>
       </defs>
       <rect width="80" height="120" fill="url(#g)"/>
       <rect x="6" y="0" width="2.5" height="120" fill="rgba(0,0,0,0.18)"/>
       <g fill="none" stroke="rgba(245,240,232,0.55)" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
         <path d="M26 46h12a5 5 0 0 1 5 5v25a4 4 0 0 0-4-4H26z"/>
         <path d="M54 46H42a5 5 0 0 0-5 5v25a4 4 0 0 1 4-4h13z"/>
       </g>
     </svg>`.replace(/\s+/g, ' ')
  );

/**
 * Drop onto any cover <img>:  <img src={url} onError={onCoverError} />
 *
 * The data-attribute guard matters: if the placeholder itself ever failed to
 * parse, re-firing onError would loop forever.
 */
export function onCoverError(e) {
  const img = e.currentTarget;
  if (img.dataset.coverFallback) return;
  img.dataset.coverFallback = '1';
  img.src = PLACEHOLDER;
}

export { PLACEHOLDER as COVER_PLACEHOLDER };
